// import external modules
import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCog,
  faShieldAlt,
  faCaretRight,
  faFingerprint,
  faServer,
  faChartArea,
  faGlobeAsia,
  faMap,
  faUniversalAccess,
  faUser,
  faKey,
  faUnlock,
  faUserCog,
  faBoxOpen,
  faExclamation,
  faCubes,
  faCodeBranch,
  faCalendarCheck,
  faList,
  faQuestion,
  faFileAlt,
  faClipboardList,
  faClipboardCheck,
  faWarehouse,
  faDolly,
  faBox,
  faBoxes,
  faPoll,
  faHandPaper,
  faChartPie,
  faTachometerAlt,
  faBraille,
} from "@fortawesome/free-solid-svg-icons";

// Styling
import "../../../../assets/scss/components/sidebar/sidemenu/sidemenu.scss";
import axios from "axios";
import SideMenu from "../sidemenuHelper";
import { withRouter } from "react-router-dom";
const userCan = require("../../../../utility/userCan");
const cookie = require("js-cookie");
class SideMenuContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: {},
      loading: false,
      permissions: [],
    };
  }
  componentDidMount = async () => {
    const Headers = {
      headers: {
        Authorization: `Bearer ${cookie.get("token")}`,
        Accept: "application/json",
      },
    };
    this.setState({
      loading: true,
    });
    const res = await axios.get("/api/profile", Headers);
    let user = res.data;
    this.setState({
      user: user,
      loading: false,
    });
  };
  render() {
    const { user, loading } = this.state;
    return (
      !loading && (
        <>
          <SideMenu
            className="sidebar-content"
            toggleSidebarMenu={this.props.toggleSidebarMenu}
          >
            <SideMenu.MenuSingleItem>
              <div
                className={
                  !userCan(user, "view-setting-security") &&
                  !userCan(user, "view-setting-system") &&
                  !userCan(user, "view-setting-province") &&
                  !userCan(user, "view-setting-country") &&
                  !userCan(user, "view-setting-distributor") &&
                  !userCan(user, "view-security-user") &&
                  !userCan(user, "view-security-role") &&
                  !userCan(user, "view-security-role-permission")
                    ? "d-none"
                    : "sidebar-label"
                }
              >
                <span className="text-main">GLOBAL</span>
              </div>
            </SideMenu.MenuSingleItem>
            <SideMenu.MenuMultiItems
              name="Setting"
              Icon={<FontAwesomeIcon icon={faCog} size="sm" />}
              ArrowRight={<FontAwesomeIcon icon={faCaretRight} size="sm" />}
              collapsedSidebar={this.props.collapsedSidebar}
              className={
                !userCan(user, "view-setting-security") &&
                !userCan(user, "view-setting-system") &&
                !userCan(user, "view-setting-province") &&
                !userCan(user, "view-setting-country") &&
                !userCan(user, "view-setting-distributor")
                  ? "d-none"
                  : ""
              }
            >
              <NavLink
                to="/setting/security"
                className={
                  userCan(user, "view-setting-security") ? "item" : "d-none"
                }
                activeclassname="active"
              >
                <i className="menu-icon">
                  <FontAwesomeIcon icon={faFingerprint} size="xs" />
                </i>
                <span className="menu-item-text">Security</span>
              </NavLink>
              <NavLink
                to="/setting/system"
                className={
                  userCan(user, "view-setting-system") ? "item" : "d-none"
                }
                activeclassname="active"
              >
                <i className="menu-icon">
                  <FontAwesomeIcon icon={faServer} size="xs" />
                </i>
                <span className="menu-item-text">System</span>
              </NavLink>
              <NavLink
                to="/setting/provinces"
                className={
                  userCan(user, "view-setting-province") ? "item" : "d-none"
                }
                activeclassname="active"
              >
                <i className="menu-icon">
                  <FontAwesomeIcon icon={faChartArea} size="xs" />
                </i>
                <span className="menu-item-text">Province</span>
              </NavLink>
              <NavLink
                to="/setting/districts"
                className={
                  userCan(user, "view-setting-district") ? "item" : "d-none"
                }
                activeclassname="active"
              >
                <i className="menu-icon">
                  <FontAwesomeIcon icon={faChartArea} size="xs" />
                </i>
                <span className="menu-item-text">District</span>
              </NavLink>
              <NavLink
                to="/setting/sub-districts"
                className={
                  userCan(user, "view-setting-sub-district") ? "item" : "d-none"
                }
                activeclassname="active"
              >
                <i className="menu-icon">
                  <FontAwesomeIcon icon={faChartArea} size="xs" />
                </i>
                <span className="menu-item-text">Sub District</span>
              </NavLink>
              <NavLink
                to="/setting/classifications"
                className={
                  userCan(user, "view-setting-classification")
                    ? "item"
                    : "d-none"
                }
                activeclassname="active"
              >
                <i className="menu-icon">
                  <FontAwesomeIcon icon={faBraille} size="xs" />
                </i>
                <span className="menu-item-text">Classification</span>
              </NavLink>
              <NavLink
                to="/setting/types"
                className={
                  userCan(user, "view-setting-type") ? "item" : "d-none"
                }
                activeclassname="active"
              >
                <i className="menu-icon">
                  <FontAwesomeIcon icon={faBoxes} size="xs" />
                </i>
                <span className="menu-item-text">Type</span>
              </NavLink>
              <NavLink
                to="/setting/regions"
                className={
                  userCan(user, "view-setting-region") ? "item" : "d-none"
                }
                activeclassname="active"
              >
                <i className="menu-icon">
                  <FontAwesomeIcon icon={faMap} size="xs" />
                </i>
                <span className="menu-item-text">Region</span>
              </NavLink>
              <NavLink
                to="/setting/countries"
                className={
                  userCan(user, "view-setting-country") ? "item" : "d-none"
                }
                activeclassname="active"
              >
                <i className="menu-icon">
                  <FontAwesomeIcon icon={faGlobeAsia} size="xs" />
                </i>
                <span className="menu-item-text">Country</span>
              </NavLink>
              <NavLink
                to="/setting/distributors"
                className={
                  userCan(user, "view-setting-distributor") ? "item" : "d-none"
                }
                activeclassname="active"
              >
                <i className="menu-icon">
                  <FontAwesomeIcon icon={faUniversalAccess} size="xs" />
                </i>
                <span className="menu-item-text">Distributor</span>
              </NavLink>

              <NavLink
                to="/setting/reason-not-appoint"
                className={
                  userCan(user, "view-setting-type") ? "item" : "d-none"
                }
                activeclassname="active"
              >
                <i className="menu-icon">
                  <FontAwesomeIcon icon={faCalendarCheck} size="xs" />
                </i>
                <span className="menu-item-text">Reason Not Appoint</span>
              </NavLink>
              <NavLink
                to="/setting/target-types"
                className={
                  userCan(user, "view-setting-target-type") ? "item" : "d-none"
                }
                activeclassname="active"
              >
                <i className="menu-icon">
                  <FontAwesomeIcon icon={faBoxes} size="xs" />
                </i>
                <span className="menu-item-text">Target Type</span>
              </NavLink>
            </SideMenu.MenuMultiItems>

            <SideMenu.MenuMultiItems
              Icon={<FontAwesomeIcon icon={faShieldAlt} size="sm" />}
              name="Securiy"
              ArrowRight={<FontAwesomeIcon icon={faCaretRight} size="sm" />}
              collapsedSidebar={this.props.collapsedSidebar}
              className={
                !userCan(user, "view-security-user") &&
                !userCan(user, "view-security-role") &&
                !userCan(user, "view-security-role-permission")
                  ? "d-none"
                  : ""
              }
            >
              <NavLink
                to="/users"
                className={
                  userCan(user, "view-security-user") ? "item" : "d-none"
                }
                className="item"
                activeclassname="active"
              >
                <i className="menu-icon">
                  <FontAwesomeIcon icon={faUser} size="xs" />
                </i>
                <span className="menu-item-text">Users</span>
              </NavLink>
              <NavLink
                to="/roles"
                className={
                  userCan(user, "view-security-role") ? "item" : "d-none"
                }
                activeclassname="active"
              >
                <i className="menu-icon">
                  <FontAwesomeIcon icon={faKey} size="xs" />
                </i>
                <span className="menu-item-text">Roles</span>
              </NavLink>
              <NavLink
                to="/rolePermission"
                className={
                  userCan(user, "view-security-role-permission")
                    ? "item"
                    : "d-none"
                }
                activeclassname="active"
              >
                <i className="menu-icon">
                  <FontAwesomeIcon icon={faUnlock} size="xs" />
                </i>
                <span className="menu-item-text">RolePermission</span>
              </NavLink>
            </SideMenu.MenuMultiItems>
            <SideMenu.MenuSingleItem>
              <div
                className={
                  !userCan(user, "view-references-customer") &&
                  !userCan(user, "view-references-product") &&
                  !userCan(user, "view-references-promotion") &&
                  !userCan(user, "view-references-category") &&
                  !userCan(user, "view-references-subsidiary") &&
                  !userCan(user, "view-maintennance-schedule") &&
                  !userCan(user, "view-maintennance-questionaire") &&
                  !userCan(user, "view-transaction-pricecheck") &&
                  !userCan(user, "view-transaction-promotioncheck") &&
                  !userCan(user, "view-transaction-shareofshelve") &&
                  !userCan(user, "view-transaction-on-shelf-availabilities") &&
                  !userCan(user, "view-transaction-stocktake") &&
                  !userCan(user, "view-transaction-survey")
                    ? "d-none"
                    : "sidebar-label"
                }
              >
                <span className="text-main">MODULES</span>
              </div>
            </SideMenu.MenuSingleItem>
            <SideMenu.MenuMultiItems
              name="References"
              ArrowRight={<FontAwesomeIcon icon={faCaretRight} size="sm" />}
              collapsedSidebar={this.props.collapsedSidebar}
              Icon={<FontAwesomeIcon icon={faCodeBranch} size="xs" />}
              className={
                !userCan(user, "view-references-customer") &&
                !userCan(user, "view-references-product") &&
                !userCan(user, "view-references-promotion") &&
                !userCan(user, "view-references-category") &&
                !userCan(user, "view-references-subsidiary")
                  ? "d-none"
                  : ""
              }
            >
              <NavLink
                to="/customers"
                className={
                  userCan(user, "view-references-customer") ? "item" : "d-none"
                }
                activeclassname="active"
              >
                <i className="menu-icon">
                  <FontAwesomeIcon icon={faUserCog} size="xs" />
                </i>
                <span className="menu-item-text">Customers</span>
              </NavLink>
              <NavLink
                to="/products"
                className={
                  userCan(user, "view-references-product") ? "item" : "d-none"
                }
                activeclassname="active"
              >
                <i className="menu-icon">
                  <FontAwesomeIcon icon={faBoxOpen} size="xs" />
                </i>
                <span className="menu-item-text">Products</span>
              </NavLink>
              <NavLink
                to="/promotions"
                className={
                  userCan(user, "view-references-promotion") ? "item" : "d-none"
                }
                activeclassname="active"
              >
                <i className="menu-icon">
                  <FontAwesomeIcon icon={faExclamation} size="xs" />
                </i>
                <span className="menu-item-text">Promotions</span>
              </NavLink>
              <NavLink
                to="/categories"
                className={
                  userCan(user, "view-references-category") ? "item" : "d-none"
                }
                activeclassname="active"
              >
                <i className="menu-icon">
                  <FontAwesomeIcon icon={faCubes} size="xs" />
                </i>
                <span className="menu-item-text">Category</span>
              </NavLink>
              <NavLink
                to="/subsidiaries"
                className={
                  userCan(user, "view-references-subsidiary")
                    ? "item"
                    : "d-none"
                }
                activeclassname="active"
              >
                <i className="menu-icon">
                  <FontAwesomeIcon icon={faChartPie} size="xs" />
                </i>
                <span className="menu-item-text">Subsidiary</span>
              </NavLink>
            </SideMenu.MenuMultiItems>
            <SideMenu.MenuMultiItems
              name="Maintenance"
              ArrowRight={<FontAwesomeIcon icon={faCaretRight} size="sm" />}
              collapsedSidebar={this.props.collapsedSidebar}
              Icon={<FontAwesomeIcon icon={faCog} size="xs" />}
              className={
                !userCan(user, "view-maintennance-schedule") &&
                !userCan(user, "view-maintennance-questionaire")
                  ? "d-none"
                  : ""
              }
            >
              {/* <NavLink
                to="/questions"
                className={"item"}
                activeclassname="active"
              >
                <i className="menu-icon">
                  <FontAwesomeIcon icon={faQuestion} size="xs" />
                </i>
                <span className="menu-item-text">Question</span>
              </NavLink> */}
              <NavLink
                to="/schedules"
                className={
                  userCan(user, "view-maintennance-schedule")
                    ? "item"
                    : "d-none"
                }
                activeclassname="active"
              >
                <i className="menu-icon">
                  <FontAwesomeIcon icon={faCalendarCheck} size="xs" />
                </i>
                <span className="menu-item-text">Scheduler</span>
              </NavLink>
              <SideMenu toggleSidebarMenu={this.props.toggleSidebarMenu}>
                <SideMenu.MenuMultiItems
                  name="Questionaire"
                  ArrowRight={<FontAwesomeIcon icon={faCaretRight} size="sm" />}
                  collapsedSidebar={this.props.collapsedSidebar}
                  Icon={<FontAwesomeIcon icon={faFileAlt} size="xs" />}
                  className={
                    userCan(user, "view-maintennance-questionaire")
                      ? "sidemenu-left-custom"
                      : "d-none"
                  }
                >
                  <NavLink
                    to="/questionaires"
                    className="item"
                    activeclassname="active"
                  >
                    <span
                      className="menu-item-text"
                      style={{ marginLeft: "15px" }}
                    >
                      <FontAwesomeIcon
                        icon={faList}
                        size="xs"
                        style={{ marginRight: "14px", fontSize: "15px" }}
                      />
                      List
                    </span>
                  </NavLink>
                  <NavLink
                    to="/questions"
                    className="item"
                    activeclassname="active"
                  >
                    <span
                      className="menu-item-text"
                      style={{ marginLeft: "15px" }}
                    >
                      <FontAwesomeIcon
                        icon={faQuestion}
                        size="xs"
                        style={{ marginRight: "14px", fontSize: "15px" }}
                      />
                      Question
                    </span>
                  </NavLink>
                </SideMenu.MenuMultiItems>
              </SideMenu>
            </SideMenu.MenuMultiItems>
            <SideMenu.MenuMultiItems
              name="Transactions"
              ArrowRight={<FontAwesomeIcon icon={faCaretRight} size="sm" />}
              collapsedSidebar={this.props.collapsedSidebar}
              Icon={<FontAwesomeIcon icon={faClipboardList} size="xs" />}
              className={
                !userCan(user, "view-transaction-pricecheck") &&
                !userCan(user, "view-transaction-promotioncheck") &&
                !userCan(user, "view-transaction-shareofshelve") &&
                !userCan(user, "view-transaction-on-shelf-availabilities") &&
                !userCan(user, "view-transaction-stocktake") &&
                !userCan(user, "view-transaction-survey")
                  ? "d-none"
                  : ""
              }
            >
              <NavLink
                to="/pricechecks"
                className={
                  userCan(user, "view-transaction-pricecheck")
                    ? "item"
                    : "d-none"
                }
                activeclassname="active"
              >
                <i className="menu-icon">
                  <FontAwesomeIcon icon={faClipboardCheck} size="xs" />
                </i>
                <span className="menu-item-text">Price Checks</span>
              </NavLink>
              <NavLink
                to="/promotionchecks"
                className={
                  userCan(user, "view-transaction-promotioncheck")
                    ? "item"
                    : "d-none"
                }
                activeclassname="active"
              >
                <i className="menu-icon">
                  <FontAwesomeIcon icon={faClipboardCheck} size="xs" />
                </i>
                <span className="menu-item-text">Promotion Checks</span>
              </NavLink>
              <NavLink
                to="/shareofshelves"
                className={
                  userCan(user, "view-transaction-shareofshelve")
                    ? "item"
                    : "d-none"
                }
                activeclassname="active"
              >
                <i className="menu-icon">
                  <FontAwesomeIcon icon={faBoxes} size="xs" />
                </i>
                <span className="menu-item-text">Share of Sheives</span>
              </NavLink>
              <NavLink
                to="/onShelfAvailabilities"
                className={
                  userCan(user, "view-transaction-on-shelf-availabilities")
                    ? "item"
                    : "d-none"
                }
                activeclassname="active"
              >
                <i className="menu-icon">
                  <FontAwesomeIcon icon={faDolly} size="xs" />
                </i>
                <span className="menu-item-text">On-Shelf Availabilities</span>
              </NavLink>
              <NavLink
                to="/stocktakes"
                className={
                  userCan(user, "view-transaction-stocktake")
                    ? "item"
                    : "d-none"
                }
                activeclassname="active"
              >
                <i className="menu-icon">
                  <FontAwesomeIcon icon={faWarehouse} size="xs" />
                </i>
                <span className="menu-item-text">Stock Takes</span>
              </NavLink>
              <NavLink
                to="/surveys"
                className={
                  userCan(user, "view-transaction-survey") ? "item" : "d-none"
                }
                activeclassname="active"
              >
                <i className="menu-icon">
                  <FontAwesomeIcon icon={faPoll} size="xs" />
                </i>
                <span className="menu-item-text">Surveys</span>
              </NavLink>
              <NavLink
                to="/posmrequests"
                className={
                  userCan(user, "view-transaction-posm-request")
                    ? "item"
                    : "d-none"
                }
                activeclassname="active"
              >
                <i className="menu-icon">
                  <FontAwesomeIcon icon={faHandPaper} size="xs" />
                </i>
                <span className="menu-item-text">POSM Requests</span>
              </NavLink>
            </SideMenu.MenuMultiItems>
            <SideMenu.MenuSingleItem>
              <div
                className={
                  !userCan(user, "view-report-pricecheck") &&
                  !userCan(user, "view-report-promotioncheck") &&
                  !userCan(user, "view-report-shareofshelve") &&
                  !userCan(user, "view-report-on-shelf-availabilities") &&
                  !userCan(user, "view-report-stocktake") &&
                  !userCan(user, "view-report-survey")
                    ? "d-none"
                    : "sidebar-label"
                }
              >
                <span className="text-main">REPORTS</span>
              </div>
            </SideMenu.MenuSingleItem>
            <SideMenu.MenuMultiItems
              className={
                !userCan(user, "view-report-pricecheck") &&
                !userCan(user, "view-report-promotioncheck") &&
                !userCan(user, "view-report-shareofshelve") &&
                !userCan(user, "view-report-on-shelf-availabilities") &&
                !userCan(user, "view-report-stocktake") &&
                !userCan(user, "view-report-survey") &&
                !userCan(user, "view-report-posm-request")
                  ? "d-none"
                  : ""
              }
              name="Transactions"
              ArrowRight={<FontAwesomeIcon icon={faCaretRight} size="sm" />}
              collapsedSidebar={this.props.collapsedSidebar}
              Icon={<FontAwesomeIcon icon={faClipboardList} size="xs" />}
            >
              <NavLink
                to="/reports/transactions/priceCheck"
                className={
                  userCan(user, "view-report-pricecheck") ? "item" : "d-none"
                }
                activeclassname="active"
              >
                <i className="menu-icon">
                  <FontAwesomeIcon icon={faClipboardCheck} size="xs" />
                </i>
                <span className="menu-item-text">Price Checks</span>
              </NavLink>
              <NavLink
                to="/reports/transactions/promotionCheck"
                className={
                  userCan(user, "view-report-promotioncheck")
                    ? "item"
                    : "d-none"
                }
                className="item"
                activeclassname="active"
              >
                <i className="menu-icon">
                  <FontAwesomeIcon icon={faClipboardCheck} size="xs" />
                </i>
                <span className="menu-item-text">Promotion Checks</span>
              </NavLink>
              <NavLink
                to="/reports/transactions/shareOfShelve"
                className={
                  userCan(user, "view-report-shareofshelve") ? "item" : "d-none"
                }
                activeclassname="active"
              >
                <i className="menu-icon">
                  <FontAwesomeIcon icon={faBoxes} size="xs" />
                </i>
                <span className="menu-item-text">Share of Sheives</span>
              </NavLink>
              <NavLink
                to="/reports/transactions/onShelfAvailable"
                className={
                  userCan(user, "view-report-on-shelf-availabilities")
                    ? "item"
                    : "d-none"
                }
                activeclassname="active"
              >
                <i className="menu-icon">
                  <FontAwesomeIcon icon={faDolly} size="xs" />
                </i>
                <span className="menu-item-text">On-Shelf Availabilities</span>
              </NavLink>
              <NavLink
                to="/reports/transactions/stockTake"
                className={
                  userCan(user, "view-report-stocktake") ? "item" : "d-none"
                }
                activeclassname="active"
              >
                <i className="menu-icon">
                  <FontAwesomeIcon icon={faWarehouse} size="xs" />
                </i>
                <span className="menu-item-text">Stock Takes</span>
              </NavLink>
              <NavLink
                to="/reports/transactions/survey"
                className={
                  userCan(user, "view-report-survey") ? "item" : "d-none"
                }
                activeclassname="active"
              >
                <i className="menu-icon">
                  <FontAwesomeIcon icon={faPoll} size="xs" />
                </i>
                <span className="menu-item-text">Surveys</span>
              </NavLink>
              <NavLink
                to="/reports/transactions/posmRequest"
                className={
                  userCan(user, "view-report-posm-request") ? "item" : "d-none"
                }
                activeclassname="active"
              >
                <i className="menu-icon">
                  <FontAwesomeIcon icon={faPoll} size="xs" />
                </i>
                <span className="menu-item-text">PosmRequest</span>
              </NavLink>
            </SideMenu.MenuMultiItems>
            <SideMenu.MenuSingleItem>
              <div className="sidebar-label">
                <span className="text-main">Dashboard</span>
              </div>
            </SideMenu.MenuSingleItem>
            <SideMenu.MenuSingleItem>
              <a
                href="https://suntory.smart-esm.com/"
                className="item"
                target="_blank"
                activeclassname="active"
              >
                <span className="">
                  <i className="">
                    <FontAwesomeIcon icon={faTachometerAlt} size="xs" />
                  </i>
                  Dashboard 1
                </span>
              </a>
            </SideMenu.MenuSingleItem>
            <SideMenu.MenuSingleItem>
              <a
                href="/snaptoroad"
                className="item"
                // target="_blank"
                // activeclassname="active"
              >
                <span className="">
                  <i className="">
                    <FontAwesomeIcon icon={faMap} size="xs" />
                  </i>
                  Snap To Road
                </span>
              </a>
            </SideMenu.MenuSingleItem>
            <SideMenu.MenuSingleItem>
              <a
                href="/distancereport"
                className="item"
              >
                <span className="">
                  <i className="">
                    <FontAwesomeIcon icon={faMap} size="xs" />
                  </i>
                  Distance Report
                </span>
              </a>
            </SideMenu.MenuSingleItem>
          </SideMenu>
        </>
      )
    );
  }
}

export default withRouter(SideMenuContent);
